import { z } from 'zod';
import '@apexdesigner/schema-tools';

export const processInfoProperty = z
  .object({
    name: z.string().nullable().optional().describe('Property name'),

    type: z
      .string()
      .nullable()
      .optional()
      .describe('References a ProcessDataType name'),

    isArray: z
      .boolean()
      .nullable()
      .optional()
      .describe('Whether this is an array'),

    required: z
      .boolean()
      .nullable()
      .optional()
      .describe('Whether a value is required to start the process'),

    isInput: z
      .boolean()
      .nullable()
      .optional()
      .describe('An input the caller maps'),

    isOutput: z
      .boolean()
      .nullable()
      .optional()
      .describe('An output the process returns'),

    description: z.string().nullable().optional().describe('Description'),
  })
  .describe(
    "A declared property of a process design a call activity can call: an input the call activity maps, or a field of the child instance's data.",
  )
  .as('ProcessInfoProperty', { embedded: true });

export { processInfoProperty as processInfoPropertySchema };
